import Box from '~/common/components/Box';
import Flex from '~/common/components/Flex';
import Stack from '~/common/components/Stacks/Stack';
import Text from '~/common/components/Texts/Text';
import Grid from '~/common/mui/Grids/Grid';
import { formatCurrency } from '~/common/util/format';
import CalculationHistory from '~/pages/IncomeCalculator/CalculationHistory/CalculationHistory';
import { AUS_METHOD_ID } from '~/pages/RentalIncome/RentalIncomeCalculation/constants';
import { PROPERTY_TYPE } from '~/pages/RentalIncome/constants';

type PageHeaderProps = {
  propertyInfo?: {
    ausMethod?: number;
    pitiaAmount?: number;
    propertyType?: number;
    realEstateOwned?: {
      reopitiaAmount?: number;
    };
  };
  includeCalculationHistory?: boolean;
};

const RentalHeader = ({
  propertyInfo,
  includeCalculationHistory = false,
}: Readonly<PageHeaderProps>) => {
  return (
    <Grid
      gridTemplateColumns="1fr 1fr"
      p={4}
      pl={8}
      pr={8}
      fontSize="sm"
      fontWeight={500}
      height="72px"
      borderBottom="1px solid"
      borderColor="gray.200"
    >
      <Box>
        <Stack direction="row">
          <Text
            data-testid="aus-method-label"
            fontSize="1rem"
            fontWeight="500"
            h={6}
          >
            AUS Type:
          </Text>
          <Text
            data-testid="aus-method-value"
            fontSize="1rem"
            fontWeight="400"
            h={6}
          >
            {propertyInfo.ausMethod === AUS_METHOD_ID.DESKTOP_UNDERWRITER
              ? 'DU'
              : 'LPA'}
          </Text>
        </Stack>
        <Stack direction="row">
          <Text
            data-testid="pitia-amount-label"
            fontSize="1rem"
            fontWeight="500"
            h={6}
          >
            PITIA:
          </Text>
          <Text
            data-testid="pitia-amount-value"
            fontSize="1rem"
            fontWeight="400"
            h={6}
          >
            {formatCurrency(
              propertyInfo.propertyType === PROPERTY_TYPE.REAL_ESTATE_OWNED
                ? propertyInfo.realEstateOwned?.reopitiaAmount
                : propertyInfo.pitiaAmount,
            )}
          </Text>
        </Stack>
      </Box>
      <Flex justifyContent="flex-end">
        {includeCalculationHistory && (
          <CalculationHistory sx={{ marginRight: '.5rem' }} />
        )}
      </Flex>
    </Grid>
  );
};

export default RentalHeader;
